import type { ReactElement } from 'react';
import { useServices, useT } from '../../../app/di';
import { useResource } from '../../../shared/hooks';
import { Alert } from '../../../ui-kit/Alert/Alert';
import { Loading } from '../../../ui-kit/Loading/Loading';
import { useBlog } from '../../accounts/workspaces';
import { MediaTrafficReport } from './MediaTrafficReport/MediaTrafficReport';

// MED-UC-7, MED-RULE-2
export function MediaTrafficSection(): ReactElement {
  const { api } = useServices();
  const { t, te } = useT();
  const { blog } = useBlog();
  const traffic = useResource(() => api.media.traffic(blog.id), [api, blog.id]);
  if (traffic.loading && !traffic.data) return <Loading label={t('common.loading')} />;
  if (traffic.error || !traffic.data) return <Alert tone="danger">{te(traffic.error ?? [])}</Alert>;
  return <MediaTrafficReport report={traffic.data} />;
}
